import DeleteConfirmationDialog from './DeleteConfirmationDialog';

export default DeleteConfirmationDialog;
